import { toast } from "react-toastify";
import AuctionPortal from "../../apis/AuctionPortal";
import history from "../../history";
import { isSessionExpired } from "../login/loginActions";
import { encryptId,decryptIndex } from "../../components/Encryption";

import {
  FETCH_EVENT_BIDDERs,
  ADD_EVENT_BIDDERs,
  REMOVE_EVENT_BIDDERs,
  USER_LOGOUT,
} from "../types";

export const fetchEventBidders = (id) => async (dispatch) => {
  if (isSessionExpired()) {
    history.push("/SessionExpired");
  } else {
    try {
      document.getElementById("spinner").classList.add("spinnerDisplay");
      const response = await AuctionPortal.get(`/event/${encryptId(id)}/buyermappingOfEvent/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });
      dispatch({ type: FETCH_EVENT_BIDDERs, payload: response.data });
      document.getElementById("spinner").classList.remove("spinnerDisplay");
    } catch (error) {
      document.getElementById("spinner").classList.remove("spinnerDisplay");
      switch (error.response.status) {
        case 408:
          history.push("/MultipleLogin");
          dispatch({ type: USER_LOGOUT });
          break;
        case 401:
          history.push("/NotAuthorised");
          break;
        case 403:
          history.push("/acessforbidden");
          break;
        case 404:
          history.push("/PageNotFound");
          break;
        case 400:
          history.push("/BadRequest");
          break;
        default:
          toast.error("Error Occurred");
      }
    }
  }
};

export const addEventBidders = (id, data) => async (dispatch) => {
  if (isSessionExpired()) {
    history.push("/SessionExpired");
  } else {
    try {
      document.getElementById("spinner").classList.add("spinnerDisplay");
      const response = await AuctionPortal.post(
        `/event/${encryptId(id)}/buyermapping/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      dispatch({ type: ADD_EVENT_BIDDERs, payload: response.data });
      document.getElementById("spinner").classList.remove("spinnerDisplay");
    } catch (error) {
      document.getElementById("spinner").classList.remove("spinnerDisplay");
      switch (error.response.status) {
        case 408:
          history.push("/MultipleLogin");
          dispatch({ type: USER_LOGOUT });
          break;
        case 401:
          history.push("/NotAuthorised");
          break;
        case 403:
          history.push("/acessforbidden");
          break;
        case 404:
          history.push("/PageNotFound");
          break;
        case 400:
          alert(JSON.stringify(error.response.data.errors));
          break;
        default:
          toast.error("Error Occurred");
      }
    }
  }
};

export const bulkAddEventBidders = (data) => async (dispatch) => {
  if (isSessionExpired()) {
    history.push("/SessionExpired");
  } else {
    try {
      document.getElementById("spinner").classList.add("spinnerDisplay");
      const response = await AuctionPortal.post(
        `/event/bulk/buyermapping/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      document.getElementById("spinner").classList.remove("spinnerDisplay");
      toast.success(response.data.message || "Bulk mapping completed successfully");
      return response.data;
    } catch (error) {
      document.getElementById("spinner").classList.remove("spinnerDisplay");
      switch (error.response?.status) {
        case 408:
          history.push("/MultipleLogin");
          dispatch({ type: USER_LOGOUT });
          break;
        case 401:
          history.push("/NotAuthorised");
          break;
        case 403:
          history.push("/acessforbidden");
          break;
        case 404:
          toast.error(error.response.data || "Not Found");
          break;
        case 400:
          toast.error(error.response.data || "Bad Request");
          break;
        default:
          toast.error("Error Occurred");
      }
    }
  }
};

export const removeEventBidders = (id, data) => async (dispatch) => {
  if (isSessionExpired()) {
    history.push("/SessionExpired");
  } else {
    try {
      document.getElementById("spinner").classList.add("spinnerDisplay");
      const response = await AuctionPortal.post(
        `/event/${encryptId(id)}/buyermapping/remove`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      dispatch({ type: REMOVE_EVENT_BIDDERs, payload: response.data });
      document.getElementById("spinner").classList.remove("spinnerDisplay");
    } catch (error) {
      document.getElementById("spinner").classList.remove("spinnerDisplay");
      switch (error.response.status) {
        case 408:
          history.push("/MultipleLogin");
          dispatch({ type: USER_LOGOUT });
          break;
        case 401:
          history.push("/NotAuthorised");
          break;
        case 403:
          history.push("/acessforbidden");
          break;
        case 404:
          history.push("/PageNotFound");
          break;
        case 400:
          alert(JSON.stringify(error.response.data.errors));
          break;
        default:
          toast.error("Error Occurred");
      }
    }
  }
};
